import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import { MSRPOperations } from '../../store/modules/msrp';

import MSRPToggle from './MSRPToggle';

interface IStateFromProps {
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
}

interface IDispatchFromProps {
  toggleMSRP(): void;
}

const mapStateToProps = (state: any) => ({
  showOnlyMSRP: state.msrp.showOnlyMSRP,
  isLoggedIn: state.signin.success
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  toggleMSRP: () => dispatch(MSRPOperations.toggleMSRP())
});

export const pureComponent = MSRPToggle;
export default connect<IStateFromProps, IDispatchFromProps, void>(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(MSRPToggle));
